import GoodsList from './goods_list.vue'

export default {
    path: 'goodsList',
    component: GoodsList
}
